import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import UpdateTicker from "@/pages/home/components/UpdateTicker";
import HeroSection from "@/pages/home/components/HeroSection";
import CollectionIndex from "@/pages/home/components/CollectionIndex";
import HotUpdateList from "@/pages/home/components/HotUpdateList";
import WatchGuide from "@/pages/home/components/WatchGuide";
import ShortVideoSets from "@/pages/home/components/ShortVideoSets";
import ResourceLookup from "@/pages/home/components/ResourceLookup";
import TopicBuzz from "@/pages/home/components/TopicBuzz";
import FaqSection from "@/pages/home/components/FaqSection";
import CTABand from "@/pages/home/components/CTABand";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <UpdateTicker />
      <main>
        <HeroSection />
        <CollectionIndex />
        <HotUpdateList />
        <WatchGuide />
        <ShortVideoSets />
        <ResourceLookup />
        <TopicBuzz />
        <FaqSection />
        <CTABand />
      </main>
      <SiteFooter />
    </div>
  );
}